/* eslint-disable */
export default {
  noResultFoundFor: 'Geen resultaat gevonden voor',
  foundFromServerHint:
    'Typ een trefwoord en druk op Enter om in te zoeken {appName}',
  notResultFoundFromServer: 'Geen resultaten gevonden',
  loading: 'Wordt geladen',
} as const;

// @key: @#@"noResultFoundFor"@#@ @source: @#@"No result found for"@#@
// @key: @#@"foundFromServerHint"@#@ @source: @#@"Type keyword and press Enter to search in {appName}"@#@
// @key: @#@"notResultFoundFromServer"@#@ @source: @#@"No results found"@#@
// @key: @#@"loading"@#@ @source: @#@"loading..."@#@
